import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AdminDashboardAppBar from "./AdminDashboardAppBar";
import AdminDashboardDrawer from "./AdminDashboardDrawer";
import { adminLogout } from "../../../services/adminService";

export default function AdminDashboardLayout({ children, user, onProfileClick, onLogout }) {
  const [drawerOpen, setDrawerOpen] = React.useState(true);
  const drawerWidth = drawerOpen ? 250 : 100;
  const navigate = useNavigate();

  // Get admin user data from localStorage
  const adminUserData = JSON.parse(localStorage.getItem('adminUserData') || '{}');
  
  // Check if admin is authenticated
  useEffect(() => {
    if (!adminUserData.token) {
      navigate('/admin');
    }
  }, [adminUserData.token, navigate]);
  
  // Default functions if not provided
  const defaultUser = user || adminUserData;
  const defaultOnProfileClick = onProfileClick || (() => console.log('Profile click not implemented'));
  const defaultOnLogout = onLogout || adminLogout;

  return (
    <Box sx={{ display: "flex", height: "100vh", bgcolor: "#f5f5f5" }}>
      {/* Drawer on the left */}
      <AdminDashboardDrawer open={drawerOpen} onToggle={() => setDrawerOpen((v) => !v)} />
      {/* Main content area - Full width with drawer consideration */}
      <Box sx={{ 
        flex: 1, 
        display: "flex", 
        flexDirection: "column", 
        width: "100%", 
        minHeight: "100vh",
        ml: `${drawerWidth}px`, // Account for drawer width
        transition: "margin-left 0.2s ease"
      }}>
        {/* AppBar at the top */}
        <AdminDashboardAppBar user={defaultUser} onProfileClick={defaultOnProfileClick} onLogout={defaultOnLogout} />
        {/* Full width main content */}
        <Box
          sx={{
            flex: 1,
            bgcolor: "#f5f5f5",
            width: "100%",
            minHeight: "calc(100vh - 72px)", // fills height minus appbar
            overflow: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
